/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GiftCheckoutSessionURL
 */
export interface GiftCheckoutSessionURL {
    /**
     * 
     * @type {string}
     * @memberof GiftCheckoutSessionURL
     */
    checkout_session_url: string | null;
}

/**
 * Check if a given object implements the GiftCheckoutSessionURL interface.
 */
export function instanceOfGiftCheckoutSessionURL(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "checkout_session_url" in value;

    return isInstance;
}

export function GiftCheckoutSessionURLFromJSON(json: any): GiftCheckoutSessionURL {
    return GiftCheckoutSessionURLFromJSONTyped(json, false);
}

export function GiftCheckoutSessionURLFromJSONTyped(json: any, ignoreDiscriminator: boolean): GiftCheckoutSessionURL {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkout_session_url': json['checkout_session_url'],
    };
}

export function GiftCheckoutSessionURLToJSON(value?: GiftCheckoutSessionURL | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkout_session_url': value.checkout_session_url,
    };
}

